// extracted by mini-css-extract-plugin
export default {"title5":"M89WRdVw","line":"DhEHdbuj"};